const M = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const series = (startYear, startMonth, returns) =>
    returns.map((r, i) => {
        const idx = startMonth + i;
        return { year: startYear + Math.floor(idx / 12), month: M[idx % 12], r };
    });

export const BOTS = [
    {
        id: "xau",
        name: "Aurum One",
        market: "Gold — XAU/USD",
        strategy: "Session-based momentum with volatility-adjusted position sizing.",
        months: series(2024, 6, [
            3.2, 1.8, -1.4, 4.1, 2.6, 0.9,
            3.8, -2.1, -3.4, 5.2, 1.1, -0.8, 2.9, 3.4, 1.6, -1.9, -2.8, 2.2,
            4.1, 3.1, -1.2, 2.8, 1.9, 3.6,
        ]),
    },
    {
        id: "wti",
        name: "Crude Pulse",
        market: "Oil — WTI Crude",
        strategy: "Inventory-cycle breakout system with hard equity stops.",
        months: series(2024, 6, [
            4.8, -3.1, 2.2, 6.1, -2.4, 1.7,
            5.3, 2.9, -4.2, 3.8, 1.4, 4.6, -1.8, 2.5, 5.9, -3.4, 2.1, 4.2,
            1.2, -2.6, 3.5, 5.1, -1.1, 2.7,
        ]),
    },
    {
        id: "idx",
        name: "Index Sentinel",
        market: "Indices — SPX / NAS",
        strategy: "Mean-reversion overlay on index futures with overnight risk filter.",
        months: series(2024, 6, [
            1.9, 1.2, 0.6, 2.4, -0.9, 1.6,
            2.1, 0.8, 1.4, -1.1, 2.6, 1.3, 0.9, 2.2, 1.7, -0.7, 1.5, 2.8,
            0.4, 1.1, 1.8, -0.5, 2.3, 1.6,
        ]),
    },
];

export function computeStats(months) {
    let equity = 100;
    let peak = 100;
    let maxDD = 0;
    let grossWin = 0;
    let grossLoss = 0;
    const curve = [{ label: "Start", equity: 100 }];
    months.forEach((m) => {
        equity *= 1 + m.r / 100;
        peak = Math.max(peak, equity);
        maxDD = Math.max(maxDD, ((peak - equity) / peak) * 100);
        if (m.r >= 0) grossWin += m.r;
        else grossLoss += -m.r;
        curve.push({ label: `${m.month} '${String(m.year).slice(2)}`, equity: +equity.toFixed(2) });
    });
    const wins = months.filter((m) => m.r >= 0).length;
    return {
        curve,
        totalReturn: equity - 100,
        maxDD,
        winRate: (wins / months.length) * 100,
        profitFactor: grossLoss ? grossWin / grossLoss : grossWin,
        bestMonth: Math.max(...months.map((m) => m.r)),
        avgMonthly: months.reduce((a, m) => a + m.r, 0) / months.length,
    };
}

export function byYear(months) {
    const years = {};
    months.forEach((m) => {
        (years[m.year] = years[m.year] || []).push(m);
    });
    return Object.entries(years).map(([year, rows]) => ({
        year,
        rows,
        ytd: (rows.reduce((eq, m) => eq * (1 + m.r / 100), 1) - 1) * 100,
    }));
}

export const MONTH_ORDER = M;
